<template>
  <f7-page name="confirm">
    <f7-navbar title="Запись" back-link></f7-navbar>
    <f7-block-title>Выбранные услуги</f7-block-title>

    <f7-list id="confirmData" media-list>
      <f7-list-item
        v-for="(cost, index) in getCosts(order.included)"
        :key="index"
        :title="cost.attributes.title"
        :subtitle="discount(cost)"
        :after="price(cost.attributes.total)"
      ></f7-list-item>
      <f7-list-item :title="title_cost" :after="price(total_cost)">
        <f7-icon slot="media" material="add_shopping_cart"></f7-icon>
      </f7-list-item>
    </f7-list>

    <f7-block-title>Запись</f7-block-title>
    <f7-list id="confirmData" media-list>
      <f7-list-item
        title="Автомобиль"
        :after="getCar(order.data[0].relationships.cars.data, order.included)"
      ></f7-list-item>
      <f7-list-item
        title="Время выполнения"
        :after="`~` + total_time + ` мин.`"
      ></f7-list-item>
      <f7-list-item
        title="Дата"
        :after="
          dateFormat(
            order.data[0].attributes.day,
            order.data[0].attributes.time
          )
        "
      ></f7-list-item>
      <f7-list-item
        title="Статус"
        :badge="order.data[0].attributes.status"
        :badge-color="colorStatus(order.data[0].attributes.status)"
      ></f7-list-item>
    </f7-list>

    <f7-block-title>Видеозапись</f7-block-title>
    <f7-block
      v-if="
        !recordEnable(
          order.data[0].attributes.day,
          order.data[0].attributes.time,
          order.data[0].meta.record
        )
      "
    >
      <p>
        {{
          recordtext(
            order.data[0].attributes.day,
            order.data[0].attributes.time,
            order.data[0].meta.record
          )
        }}
      </p>
    </f7-block>
    <f7-block
      v-if="
        recordEnable(
          order.data[0].attributes.day,
          order.data[0].attributes.time,
          order.data[0].meta.record
        )
      "
    >
      <div class="camrec">
        <f7-col v-show="preloader" class="text-align-center">
          <f7-preloader></f7-preloader>
        </f7-col>
        <iframe
          width="560"
          height="315"
          frameborder="0"
          allowfullscreen
          :src="order.data[0].meta.record"
        ></iframe>
      </div>
    </f7-block>
    <f7-block v-if="isEnable">
      <f7-row tag="p">
        <f7-col tag="span">
          <f7-button round @click="checkForm()" raised>Отменить</f7-button>
        </f7-col>
      </f7-row>
    </f7-block>
  </f7-page>
</template>
<script>
export default {
  data() {
    return {
      total_cost: 0,
      total_time: 0,
      title_cost: "Стоимость",
      order: {
        data: [
          {
            type: "orders",
            id: "1",
            attributes: {
              day: "2020-04-16",
              time: "09:00",
              status: "Отклонен",
              rating: "0",
              comment: "",
            },
            relationships: {
              costs: {
                data: [
                  {
                    type: "costs",
                    id: "1",
                  },
                ],
              },
              cars: {
                data: [
                  {
                    type: "cars",
                    id: "1",
                  },
                ],
              },
            },
            meta: {
              record: "https://cam.ntks.ru/",
            },
          },
        ],
        included: [
          {
            type: "costs",
            id: "1",
            attributes: {
              price: 0,
              discount: 0,
              total: 0,
              duration: 0,
              title: "",
              body: "",
            },
          },
          {
            type: "cars",
            id: "1",
            attributes: {
              carBrand: "",
              stateNumber: "",
              category: "",
              color: "",
            },
          },
        ],
      },
      id: this.$f7route.context.id,
      isEnable: false,
      preloader: true,
    };
  },
  methods: {
    discount(cost) {
      if (cost.attributes.discount > 0) {
        this.title_cost = "Стоимость со скидкой";
        return (
          cost.attributes.price +
          ` ₽ - ` +
          cost.attributes.discount +
          `% скидка`
        );
      }
    },
    getCosts(data = []) {
      var i = 0;
      var costs = [];
      data.forEach(function (cost) {
        if (cost.type == "costs") {
          costs.push(data[i]);
          console.log(data[i]);
        }
        i++;
      });
      return costs;
    },
    recordtext(date, time, link) {
      var now = new Date();
      let current_datetime = new Date(date + "T" + time + "+05:00");
      let days = (now - current_datetime) / 1000 / 60 / 60 / 24;
      let text = "Видеозапись недоступна.";

      if (link == "") {
        return text;
      }
      if (
        this.order.data[0].attributes.status == "В записи" &&
        now < current_datetime
      ) {
        text =
          "Видеозапись будет доступна " +
          this.dateFormat(date, time, 1) +
          " и следующие 3 дня.";
      }
      if (this.order.data[0].attributes.status == "Выполнен" && days > 3) {
        text = "Видеозапись недоступна.";
      }

      return text;
    },
    recordEnable(date, time, link) {
      var now = new Date();
      let current_datetime = new Date(date + "T" + time + "+05:00");
      let days = (now - current_datetime) / 1000 / 60 / 60 / 24;

      if (link == "") {
        // console.log("false");
        return false;
      }
      if (
        (this.order.data[0].attributes.status == "В записи" ||
          this.order.data[0].attributes.status == "Выполнен") &&
        now > current_datetime
      ) {
        if (days <= 3) {
          return true;
        } else {
          return false;
        }
      } else {
        // console.log("false");
        return false;
      }
    },
    price(price) {
      return parseInt(price).toLocaleString("ru-RU") + ` ₽`;
    },
    calculation() {
      this.$f7ready((f7) => {
        let that = this;
        let id = that.id;
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/orders/" + id,
          method: "GET",
          dataType: "json",
          data: "",
          success: function (data, status) {
            if (data.data != null) {
              // console.log(data);
              that.order = data;
              data.included.forEach(function (calc) {
                if (calc.type == "costs") {
                  that.total_cost += parseInt(calc.attributes.total);
                  that.total_time += parseInt(calc.attributes.duration);
                }
              });
              that.isEnable = data.data[0].attributes.status == "В записи";
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(error.detail, "Ошибка " + error.status);
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
    colorStatus(status) {
      switch (status) {
        case "В записи":
          return "green";
        default:
          return "gray";
      }
    },
    dateFormat(date, time, format = 0) {
      function appendLeadingZeroes(n) {
        if (n <= 9) {
          return "0" + n;
        }
        return n;
      }
      const months = [
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря",
      ];
      var now = new Date();
      let current_datetime = new Date(date + "T" + time + "+05:00");
      let year =
        now.getFullYear() == current_datetime.getFullYear()
          ? ""
          : " " + current_datetime.getFullYear();
      let formatted_date0 =
        current_datetime.getDate() +
        " " +
        months[current_datetime.getMonth()] +
        year +
        ", " +
        appendLeadingZeroes(current_datetime.getHours()) +
        ":" +
        appendLeadingZeroes(current_datetime.getMinutes());

      let formatted_date1 =
        current_datetime.getDate() +
        " " +
        months[current_datetime.getMonth()] +
        year +
        " в " +
        appendLeadingZeroes(current_datetime.getHours()) +
        ":" +
        appendLeadingZeroes(current_datetime.getMinutes());

      return format == 0 ? formatted_date0 : formatted_date1;
    },
    checkForm() {
      console.log("отмена");
      this.$f7ready((f7) => {
        let that = this;
        f7.dialog.confirm(
          `Вы действительно хотите отменить заказ на ${that.dateFormat(
            that.order.data[0].attributes.day,
            that.order.data[0].attributes.time
          )} `,
          "Вопрос",
          function () {
            f7.request({
              url:
                "https://ms.bctip.ru/admin/api/typomojka/v1/orders/" + that.id,
              method: "DELETE",
              dataType: "json",
              data: "",
              success: function (data, status) {
                if (data.data != null) {
                  var toast = f7.toast.create({
                    text: `Заказ на ${that.dateFormat(
                      that.order.data[0].attributes.day,
                      that.order.data[0].attributes.time
                    )} отменен.`,
                    closeTimeout: 5000,
                  });
                  toast.open();
                  that.$f7router.back("/history/", { force: true });
                }
              },
              error: function (XMLHttpRequest, textStatus, errorThrown) {
                let data = JSON.parse(XMLHttpRequest.response);
                if (data.errors != null) {
                  data.errors.forEach(function (error) {
                    f7.dialog.alert(error.detail, "Ошибка " + error.status);
                  });
                } else {
                  f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
                }
              },
              beforeSend: function (xhr, settings) {
                xhr.setRequestHeader(
                  "authorization",
                  "Bearer " + localStorage.getItem("token")
                );
              }, //set tokenString before send
            });
          }
        );
      });
    },
    сancel() {},
    getCar(data = [], included = []) {
      let list = [];
      // console.log(included);
      data.forEach(function (car) {
        included.forEach(function (cars) {
          if (car.id == cars.id) {
            list.push(
              cars.attributes.carBrand + ", " + cars.attributes.stateNumber
            );
          }
        });
      });
      return list.join(", ");
    },
  },
  mounted: function () {
    this.calculation();
  },
};
</script>
